import { z } from "zod"
import { IdeaTypeSchema } from "./idea"

export const FeedCollectionTypeSchema = IdeaTypeSchema
export type FeedCollectionType = z.infer<typeof FeedCollectionTypeSchema>

export const FeedHotspotSchema = z.object({
  /** Position on the image as a percentage of width (0-100). */
  x: z.number().min(0).max(100),
  /** Position on the image as a percentage of height (0-100). */
  y: z.number().min(0).max(100),
  productId: z.string(),
  productName: z.string(),
  brand: z.string(),
  /** Price in base currency (RUB); clients convert for display. */
  price: z.number(),
  photo: z.string(),
})
export type FeedHotspot = z.infer<typeof FeedHotspotSchema>

export const FeedImageSchema = z.object({
  url: z.string(),
  hotspots: z.array(FeedHotspotSchema),
})
export type FeedImage = z.infer<typeof FeedImageSchema>

export const FeedCollectionSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  description: z.string(),
  type: FeedCollectionTypeSchema,
  /** First image URL, kept flat for feed-wall covers. */
  cover: z.string(),
  author: z.string(),
  productCount: z.number().int().nonnegative(),
  /** Сумма цен товаров коллекции (для бейджа «N ₽» на карточке идеи). */
  totalPrice: z.number().nonnegative().default(0),
  /** Every product in the collection. */
  productIds: z.array(z.string()),
  /** Hotspots on the cover image. */
  hotspots: z.array(FeedHotspotSchema),
  /** Full gallery; defaults to [] for older payloads. */
  images: z.array(FeedImageSchema).default([]),
})
export type FeedCollection = z.infer<typeof FeedCollectionSchema>

export const ProductCollectionParticipationSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  description: z.string(),
  type: FeedCollectionTypeSchema,
  cover: z.string(),
  author: z.string(),
  productCount: z.number().int().nonnegative(),
  productIds: z.array(z.string()),
  source: z.enum(["seller_idea", "seller_collection", "buyer_collection", "editorial"]),
})
export type ProductCollectionParticipation = z.infer<typeof ProductCollectionParticipationSchema>
